<template>
	<CarbarLink v-bind="$attrs" class="" :class="[]" @click="onClick">
		<div class="flex w-full justify-start">
			<div
				class="flex items-center"
				:class="[iconOnLeft ? '' : 'flex-row-reverse', wrapperClass]"
			>
				<div :class="[iconWrapperClass]">
					<slot name="icon">
						<IconArrowRightMenu
							class="m-auto"
							:class="[
								iconWidth,
								iconHeight,
								iconColor,
								iconClass,
							]"
						/>
					</slot>
				</div>

				<div :class="[iconGap]"></div>

				<div
					class="leading-none"
					:class="[secondary ? 'text-base' : linkTextSize]"
				>
					<slot>Link With Icon</slot>
				</div>
			</div>
		</div>
	</CarbarLink>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import IconArrowRightMenu from '@/assets/svg/common/ico-arrow-right-menu.svg'

const props = defineProps({
	iconOnLeft: {
		type: Boolean,
		default: true,
		required: false,
	},
	// note - `gap-` utilities are NOT yet supported in old iOS devices :(
	// hence the ugly `w-` hack until https://caniuse.com/?search=gap is better
	iconGap: {
		type: String,
		default: 'w-2',
		required: false,
	},
	iconWidth: {
		type: String,
		required: false,
		default: '',
	},
	iconHeight: {
		type: String,
		required: false,
		default: '',
	},
	iconColor: {
		type: String,
		required: false,
		default: 'text-gray-600',
	},
	wrapperClass: {
		type: String,
		required: false,
		default: '',
	},
	iconWrapperClass: {
		type: String,
		required: false,
		default: '',
	},
	iconClass: {
		type: String,
		required: false,
		default: '',
	},
	linkTextSize: {
		type: String,
		required: false,
		default: '',
	},
	secondary: {
		type: Boolean,
		required: false,
		default: false,
	},
})

const emit = defineEmits(['click'])

const onClick = (event) => {
	emit('click', event)
}
</script>
